import { Heading } from 'ui-kit/typography'
import { ScenarioTemplateCompact } from 'routes/Scenarios/helpers/types'
import { Link } from 'ui-kit/actions/link/Link'
import { ScenariosCard } from 'routes/components/Features/ScenarioCard'
import { getIntegrationUrl } from 'routes/Integrations/helpers'
import { INTEGRATION_QUERIES } from 'routes/constants'
import clsx from 'clsx'
import classes from './IntegrationPageScenarios.module.scss'

const INITIAL_SCENARIOS_COUNT = 6

export function IntegrationPageScenarios({
  integrationName,
  integrationKey,
  scenariosAmount,
  scenarios,
}: {
  integrationName: string
  integrationKey: string
  scenariosAmount: number
  scenarios: ScenarioTemplateCompact[]
}) {
  if (!scenarios?.length) {
    return null
  }

  const isMoreScenariosAvailable = scenarios.length > INITIAL_SCENARIOS_COUNT

  const visibleScenarios = scenarios.slice(0, INITIAL_SCENARIOS_COUNT)

  const hasSingleItem = visibleScenarios.length === 1

  return (
    <section className={classes.section}>
      <div className={classes.wrapper}>
        <Heading as={'h2'} size={'xl'} center>
          Integration Scenarios
        </Heading>

        <ul
          className={clsx(classes.list, hasSingleItem && classes.list__single)}
        >
          {visibleScenarios.map((scenario) => (
            <IntegrationPageScenariosCard
              key={scenario.key}
              scenario={scenario}
              integrationKey={integrationKey}
            />
          ))}
        </ul>

        {isMoreScenariosAvailable && (
          <Link
            className={classes.link}
            type='secondary'
            href={getIntegrationUrl(
              integrationKey,
              INTEGRATION_QUERIES.SCENARIOS,
            )}
            target='_self'
          >
            Explore all {scenariosAmount} scenarios available for{' '}
            {integrationName}
          </Link>
        )}
      </div>
    </section>
  )
}

const IntegrationPageScenariosCard = ({
  scenario,
  integrationKey,
}: {
  scenario: ScenarioTemplateCompact
  integrationKey: string
}) => {
  const scenarioPageLink = getIntegrationUrl(
    integrationKey,
    INTEGRATION_QUERIES.SCENARIOS,
    scenario.key,
  )

  return (
    <li className={classes.item}>
      <ScenariosCard
        scenario={scenario}
        href={scenarioPageLink}
        isVertical
        className={classes.card}
      />
    </li>
  )
}
